
import { HashRouter , Routes, Route, useLocation } from 'react-router-dom'
import Home from './components/Home';
import Training from './components/NavComponents/Training';
import Footer from './components/Footer';
import Copyright from './components/Copyright';
import About from './about/About';
import Fixed from './components/Fixed';
import FacultyGeodesy from './components/faculty/FacultyGeodesy';
import FacultyPhotogrammetry from './components/faculty/FacultyPhotogrammetry';
import LoginForm from './components/forms/Login';
import Faq from './components/FAQ/faq';
import Signup from './Dashboard/Signup'
import NigstCampus from './about/Nigst_campus';
import OpenPageFromTop from './components/OpenPageFromTop';
import BoardOfGovernance from './about/Board_of_governance';
import Publicgrievance from './components/publicgrievances/Publicgrievance';
import Websitepolicy from './components/Policies/Websitepolicy';
import FacultyCarto from './components/faculty/FacultyCarto';
import FacultyGeo from './components/faculty/FacultyGeo';
import BoardOfEvaluation from './about/Board_of_evaluation';
import BoardOfStudies from './about/Board_of_studies';
import Privacypolicy from './components/Policies/Privacypolicy';
import Hyperlinkpolicy from './components/Policies/Hyperlinkpolicy';
import { Feesandpayment } from './components/NavComponents/Feesandpayment/Feesandpayment';
import Location from './components/NavComponents/Location/Location';
import Copyrightpolicy from './components/Policies/Copyrightpolicy';
import ContactForm from './components/forms/Contactus';
import ForgotPasswordForm from './components/forms/forgetpassword';
import Carousel from './components/Gallery/gallery';
import Geospatialpolicy from './components/Geospatial/geospatial';
import RajBhasha from './components/rajbhasha/rajbhasha';
import NavigationMenu from './components/SiteMap/sitemap';
import Citizen from './components/NavComponents/citizencharacter/citizen';
import Student from './Dashboard/Student';
import Private from './Private';
import VerificationPage from './Dashboard/VerificationPage';
import ResetPassword from './components/forms/ResetPassword';
import CourseCalender from './components/CourseCalender';
import ContentReviewPolicy from './components/Policies/ContentReviewPolicy';
import ContentArchivalPolicy from './components/Policies/ContentArchivalPolicy';
import SecurityPolicy from './components/Policies/SecurityPolicy';
import HeadBiography from './about/HeadBiohraphy';
import RTI from './components/RTI';
import GovernanceData from './about/GovernanceData';
import ProjctReport from './components/pages/ProjectReport';
import HostelInfo from './components/pages/HostelInfo';
import ResearchAndDevelopment from './components/pages/ResearchAndDevelopment';
import NVCET from './components/pages/NCVET';

function App() {
  
  return (
        <HashRouter>
          <RouterContent />
        </HashRouter>
      );
    };
    
    const RouterContent = () => {
      const location = useLocation();
    
      // Function to check if the current path matches "/student"
      const isStudentRoute = () => {
        return location.pathname === "/student";
      };
  
     
      return (
        <>
          {!isStudentRoute() &&<OpenPageFromTop />}
          {!isStudentRoute() &&<Fixed />}
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/training' element={<Training />} />
            <Route path='/about/introduction' element={<About />} />
            <Route path='/faculty/geodesy' element={<FacultyGeodesy />} />
            <Route path='/about/nigst_campus' element={<NigstCampus />} />
            <Route path='/registration' element={<Signup />} />
            <Route path='/about/governance/board_of_governance' element={<BoardOfGovernance />} />
            <Route path='/about/governance/board_of_evaluation' element={<BoardOfEvaluation />} />
            <Route path='/about/governance/board_of_studies' element={<BoardOfStudies />} />
            <Route path='/login' element={<LoginForm />} />
            <Route path='/faq' element={<Faq />} />
            <Route path='/privacypolicy' element={<Privacypolicy />} />
            <Route path='/publicgrievances' element={<Publicgrievance />} />
            <Route path='/websitepolicy' element={<Websitepolicy />} />
            <Route path='/faculty/cartography' element={<FacultyCarto />} />
            <Route path='/faculty/photogrammetry' element={<FacultyPhotogrammetry />} />
            <Route path='/faculty/geo_ict' element={<FacultyGeo />} />
            <Route path='/location' element={<Location />} />
            <Route path='/components/FAQ/faq' element={<Faq />} />
            <Route path='/Policies/Privacypolicy' element={<Privacypolicy />} />
            <Route path='/components/publicgrievances/Publicgrievance' element={<Publicgrievance />} />
            <Route path='/components/Policies/Websitepolicy' element={<Websitepolicy />} />
            <Route path='/components/Policies/content-review-policy' element={<ContentReviewPolicy />} />
            <Route path='/components/Policies/content-archival-policy' element={<ContentArchivalPolicy />} />
            <Route path='/components/Policies/security-policy' element={<SecurityPolicy />} />
            <Route path='/rti' element={<RTI />} />
            <Route path='/Hyperlinkpolicy' element={<Hyperlinkpolicy />} />
            <Route path='/Feesandpayment' element={<Feesandpayment />} />
            <Route path='/Location' element={<Location />} />
            <Route path='/Copyrightpolicy' element={<Copyrightpolicy />} />
            <Route path='/Contactus' element={<ContactForm />} />
            <Route path='/components/forms/forgetpassword' element={<ForgotPasswordForm />} />
            <Route path='/gallery' element={<Carousel />} />
            <Route path='/components/geospatial' element={<Geospatialpolicy />} />
            <Route path='/components/rajbhasha/rajbhasha' element={<RajBhasha />} />
            <Route path='/components/SiteMap/sitemap' element={<NavigationMenu />} />
            <Route path='/citizen' element={<Citizen />} />
            <Route path='/reset/:token' element={<ResetPassword/>}></Route>
            <Route path='/courses' element={<CourseCalender/>}></Route>
            <Route path='/head-biography' element={<HeadBiography/>}></Route>
            <Route path='/governance-data' element={<GovernanceData/>}></Route>
            <Route path='/project-report' element={<ProjctReport/>}></Route>
            <Route path='/hostel-info' element={<HostelInfo/>}></Route>
            <Route path='/research-development' element={<ResearchAndDevelopment/>}></Route>
            <Route path='/ncvet' element={<NVCET/>}></Route>
            <Route
              path='/student'
              element={<Private><Student /></Private>}
            />
            <Route
              path='/verification'
              element={<Private><VerificationPage /></Private>}
            />
          </Routes>
          {!isStudentRoute() && <Footer />}
          {!isStudentRoute() &&<Copyright />}
        </>
      );
    };
    
    export default App;
    




